/**
 * custom-cart.js
 * Cart drawer enhancements for Broadcast theme.
 *
 * Currently handles:
 *   - Inserting a <br> after the second word of each cart item title so long
 *     product names wrap cleanly at a predictable point.
 */
(function () {
  'use strict';

  // ── Title wrapping ──────────────────────────────────────────────────────────
  // Splits product title text after the second word and injects a <br> so the
  // first line always shows exactly two words.  A non-breaking space joins the
  // first two words so they cannot be separated by the browser's own wrapping.
  //
  // data-title-wrapped guards against double-processing on repeated calls.

  function wrapTitle(titleEl) {
    if (titleEl.dataset.titleWrapped) return;
    var link = titleEl.querySelector('a');
    if (!link) return;
    var words = link.textContent.trim().split(/\s+/);
    if (words.length <= 2) return; // nothing to split
    link.innerHTML =
      words.slice(0, 2).join('\u00a0') + // non-breaking space between word 1 & 2
      '<br>' +
      words.slice(2).join(' ');
    titleEl.dataset.titleWrapped = '1';
  }

  function processAllTitles() {
    document.querySelectorAll(
      '.drawer__items .cart__item__title:not([data-title-wrapped])'
    ).forEach(wrapTitle);
  }

  // ── Initialisation ──────────────────────────────────────────────────────────

  function init() {
    processAllTitles();

    // Watch [data-items-holder] (cart-items.drawer__items) for AJAX cart updates.
    // When Shopify rewrites the item list, new title elements appear without the
    // data-title-wrapped attribute, so processAllTitles picks them up again.
    var holder = document.querySelector('[data-items-holder]');
    if (holder) {
      new MutationObserver(processAllTitles).observe(holder, {
        childList: true,
        subtree: true,
      });
    }

    // Also run each time the cart drawer is opened (class 'is-open' added to
    // the cart-drawer custom element by the theme's JS).
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        if (drawer.classList.contains('is-open')) {
          processAllTitles();
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
